module.exports = __webpack_public_path__ + "img/logo_gate_io.9f36b06.png";